import axios from 'axios';

const unassignSupraLockbox = async (serialNumber: string, userId: string) => {
  await axios.post('/supra/lockbox/unassign', {
    serialNumber,
    userId,
  });
};

export default unassignSupraLockbox;
